module.exports = {
      id: "apartment-usage",
      viewBox: "0 0 13.2 18",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#apartment-usage",
      toString: function () {
        return this.url;
      }
    }